import { sameServiceType } from 'src/logic/serviceType';
import { useSingleStudentDetailsQuery } from 'src/pages/single-student/singleStudentApi';

export const useStudentHasServiceType = (
  studentId: string | undefined,
  serviceType: string,
): boolean => {
  const { data: student } = useSingleStudentDetailsQuery(studentId!, {
    skip: !studentId,
  });

  return sameServiceType(student?.serviceType, serviceType);
};
